import { render, staticRenderFns } from "./create-shopping-cart-koi.vue?vue&type=template&id=6a72f32b&scoped=true"
import script from "./create-shopping-cart-koi.vue?vue&type=script&lang=js"
export * from "./create-shopping-cart-koi.vue?vue&type=script&lang=js"
import style0 from "./create-shopping-cart-koi.vue?vue&type=style&index=0&id=6a72f32b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72f32b",
  null
  
)

export default component.exports